import React from 'react';
import MuiTextField, { TextFieldProps } from '@mui/material/TextField';

const getLabelMaxWidth = (label?: string) => {
    const safeLabel = label ?? '';
    const percentage = Math.min(Math.max(safeLabel.length * 7.5, 100), 170);
    return `${percentage}%`;
};

const ShrinkLabelTextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
    ({ label, sx, InputLabelProps, ...props }, ref) => {
        const baseLabelStyles = {
            overflow: 'visible',
            maxWidth: label ? getLabelMaxWidth(String(label)) : '100%',
            backgroundColor: 'white',
            padding: '0 5px',
            marginLeft: '-4px',
            marginTop: '-1px',
            borderRadius: '4px',
            whiteSpace: 'nowrap',
        };

        return (
            <MuiTextField
                {...props}
                ref={ref}
                label={label}
                sx={{
                    ...sx,
                    '& .MuiInputLabel-root': baseLabelStyles,
                    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
                        ...baseLabelStyles,
                        transform: 'translate(14px, -10px) scale(0.75)',
                        paddingRight: '5px',
                    },
                }}
                InputLabelProps={{
                    ...InputLabelProps,
                    sx: {
                        overflow: 'visible',
                        ...(InputLabelProps?.sx ?? {}),
                    },
                }}
            />
        );
    }
);

ShrinkLabelTextField.displayName = 'ShrinkLabelTextField';

export default ShrinkLabelTextField;
